import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

// styles
import { SideNavContainer, IntegrationCardContainer, IntegrationsContainer, StyledInput, StyledInputGroup, SideNavFooter, Header, HeaderTitle, StyledCheckboxGroup, StyledCheckbox, StyledCheckboxTextGroup, StyledInputHeader } from './styles';

// Redux
import { apiAddCommsRequest, apiPatchCommsRequest, } from 'Redux/actions/channel';

// Constants
import { OrgIntegrations } from 'Config/integrationsConstant';

const OrgIntegrationsSidebarContent = ({
	onRightNavClose,
	selectedOrgId,
	selectedIntegrationData,
	updateSelectedIntegrationData,
	isEdit,
}) => {
	const dispatch = useDispatch();

	// useSelector
	const auth = useSelector(state => state.auth);

	const onDataChange = (newValue, key) => {
		const newIntegrationData = {...selectedIntegrationData};
		newIntegrationData[key] = newValue;
		updateSelectedIntegrationData(newIntegrationData);
	};

	const removeSpace = () => {
		const newIntegrationData = {...selectedIntegrationData};
		for (const key in newIntegrationData) {
			if (typeof newIntegrationData[key] === "string") {
				newIntegrationData[key] = newIntegrationData[key].trim();
			}
		}
		updateSelectedIntegrationData(newIntegrationData);
	}

	const onApplyBtnClick = () => {
		removeSpace();
		if (selectedIntegrationData?.url !== "") {
			try {
				new URL(selectedIntegrationData?.url);
			} catch {
				toast.error('Invalid URL. Please update the URL for this integration.',{
					autoClose: 3500,
					hideProgressBar: false,
				});
				return;
			}
		}
		if (isEdit) { // Update
			const updateData = {
				organisation: selectedOrgId,
				...selectedIntegrationData
			};
			dispatch(apiPatchCommsRequest(selectedIntegrationData.id, null, updateData, auth.token, true));
		} else { // Create
			const result = {
				organisation: selectedOrgId,
				type: selectedIntegrationData.type,
				title: selectedIntegrationData.title,
				url: selectedIntegrationData.url,
				is_copy_to_projects: selectedIntegrationData.is_copy_to_projects,
			};
			dispatch(apiAddCommsRequest(result, auth.token, true));
		};
		updateSelectedIntegrationData({});
		onRightNavClose();
	};

	return (
		<SideNavContainer>
			<IntegrationsContainer>
				<IntegrationCardContainer>
					<Header>
						<HeaderTitle>Integration Type: {OrgIntegrations[selectedIntegrationData?.type]?.name ?? ''}</HeaderTitle>
					</Header>

					<StyledInputGroup>
						<StyledInputHeader>Title</StyledInputHeader>
						<StyledInput
							type="text"
							value={selectedIntegrationData?.title}
							onChange={(e) => {onDataChange(e.target.value, 'title')}}
							placeholder="Default Title"
						/>
					</StyledInputGroup>

					<StyledInputGroup>
						<StyledInputHeader>URL</StyledInputHeader>
						<StyledInput
							type="text"
							value={selectedIntegrationData?.url}
							onChange={(e) => {onDataChange(e.target.value, 'url')}}
							placeholder="https://"
						/>
					</StyledInputGroup>

					<StyledCheckboxGroup>
						<StyledCheckbox
							type="checkbox"
							checked={selectedIntegrationData?.is_copy_to_projects}
							onChange={(e) => {onDataChange(e.target.checked, 'is_copy_to_projects')}}
						/>
						<StyledCheckboxTextGroup>
							<StyledInputHeader>Automatically add to New Projects</StyledInputHeader>
							<span>When checked, this integration will be added to any new projects in this organization.</span>
						</StyledCheckboxTextGroup>
					</StyledCheckboxGroup>
				</IntegrationCardContainer>
			</IntegrationsContainer>
			<SideNavFooter>
				<Button variant="secondary" size="sm" onClick={onRightNavClose}>
					Cancel
				</Button>
				<Button variant="primary" size="sm" onClick={onApplyBtnClick}>
					Apply
				</Button>
			</SideNavFooter>
		</SideNavContainer>
	);
};

export default OrgIntegrationsSidebarContent;
